// extracted by mini-css-extract-plugin
export var contentBox = "category-map-content-module--contentBox--G-eJd";